// extracted by mini-css-extract-plugin
export default {"reportDownload":"ReportDownload_reportDownload__QCzS6","reportLabel":"ReportDownload_reportLabel__UK7ys","reportLink":"ReportDownload_reportLink__9IppO"};